import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

import { FlagConfig } from 'app/shared/typings/featureFlags';
import { GET_FEATURE_FLAGS } from 'app/shared/graphql/featureFlags/queries';

export interface FeatureFlagEnabled {
  featureFlagEnabled: boolean;
  name: string;
  experimentEligible: boolean;
  variant?: string | null;
}

interface GetFeatureFlagsProps {
  flags: string[];
  flagConfigs?: FlagConfig[];
  flipperId?: string | null;
  shouldLoadFlags?: boolean;
}

export interface GetFeatureFlagsData {
  featureFlags: FeatureFlagEnabled[];
}

export const GetFeatureFlags = ({
  flags,
  flagConfigs,
  flipperId,
  shouldLoadFlags = true,
}: GetFeatureFlagsProps) => {
  const variables = {
    flags,
    ...(flagConfigs && { flagConfigs }),
    ...(flipperId && { flipperId }),
  };

  const [loadFeatureFlags, response] = useLazyQuery<GetFeatureFlagsData>(
    GET_FEATURE_FLAGS,
    {
      variables,
      fetchPolicy: 'no-cache',
    }
  );

  const flagsKey = flags.join(',');

  useEffect(() => {
    if (flags.length > 0 && shouldLoadFlags) {
      loadFeatureFlags({ variables });
    }
  }, [shouldLoadFlags, flagsKey]);

  return response;
};
